import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  reporting: {},
  getReportingStatus: IDLE,

  profitabilityReporting: {},
  getProfitabilityReportingStatus: IDLE,

  riskOutliersReporting: {},
  getRiskOutliersReportingStatus: IDLE,

  totalSettlements: 0
};

const reportingSlice = createSlice({
  name: 'reporting',
  initialState,
  reducers: {
    getReporting(state) {
      state.getReportingStatus = LOADING;
    },
    getReportingSucceeded(state, action) {
      state.reporting = action.payload;
      state.totalSettlements = parseInt(action.payload.settlements_total, 10);
      state.getReportingStatus = SUCCEEDED;
    },
    getReportingFailed(state) {
      state.getReportingStatus = FAILED;
    },

    getProfitabilityReporting(state) {
      state.getProfitabilityReportingStatus = LOADING;
    },
    getProfitabilityReportingSucceeded(state, action) {
      state.profitabilityReporting = action.payload;
      state.getProfitabilityReportingStatus = SUCCEEDED;
    },
    getProfitabilityReportingFailed(state) {
      state.getProfitabilityReportingStatus = FAILED;
    },

    getRiskOutliersReporting(state) {
      state.getRiskOutliersReportingStatus = LOADING;
    },
    getRiskOutliersReportingSucceeded(state, action) {
      state.riskOutliersReporting = action.payload;
      state.getRiskOutliersReportingStatus = SUCCEEDED;
    },
    getRiskOutliersReportingFailed(state) {
      state.getRiskOutliersReportingStatus = FAILED;
    }
  }
});

export const {
  getReporting,
  getReportingSucceeded,
  getReportingFailed,
  getProfitabilityReporting,
  getProfitabilityReportingSucceeded,
  getProfitabilityReportingFailed,
  getRiskOutliersReporting,
  getRiskOutliersReportingSucceeded,
  getRiskOutliersReportingFailed
} = reportingSlice.actions;

export default reportingSlice.reducer;
